module.exports = __webpack_public_path__ + "img/Frame_08.9f66d437.png";